import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Debate() {
  const [topic, setTopic] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const load = useCallback(async () => {
    const r = await api.get("/debate"); setItems(r.data);
  }, []);
  useEffect(() => { load(); }, [load]);

  const start = async () => {
    if (!topic) return;
    setLoading(true);
    try { await api.post("/debate", { topic }); toast.success("Debate generated"); setTopic(""); load(); }
    catch(e) { toast.error(e?.response?.data?.detail || "Failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-5xl mx-auto px-6 py-12" data-testid="debate-page">
      <div className="text-xs uppercase tracking-[0.2em] text-blue-600 font-bold">AI Debates</div>
      <h1 className="font-display text-4xl font-black text-slate-900 mb-6">Three frontier minds. One topic.</h1>
      <div className="border border-slate-200 rounded p-5 bg-white mb-6">
        <div className="flex gap-2">
          <Input placeholder="Enter a topic e.g. 'Should bootstrapped Indian SaaS flip to Delaware C-Corp?'" value={topic} onChange={e=>setTopic(e.target.value)} data-testid="debate-topic"/>
          <Button onClick={start} disabled={loading} className="btn-accent" data-testid="start-debate-btn"><Sparkles className="w-4 h-4 mr-1"/>{loading?"Debating…":"Generate"}</Button>
        </div>
        <div className="text-xs text-slate-500 mt-2">GPT-5 (FOR) · Claude Sonnet 4.5 (AGAINST) · Gemini 3 Flash (Neutral summary)</div>
      </div>

      <div className="space-y-5">
        {items.map(d => (
          <div key={d.debate_id} className="border border-slate-200 rounded bg-white" data-testid={`debate-${d.debate_id}`}>
            <div className="p-5 border-b border-slate-200">
              <div className="text-xs uppercase tracking-widest text-blue-600 font-bold mb-1">Topic</div>
              <h3 className="font-display text-2xl font-bold text-slate-900">{d.topic}</h3>
            </div>
            <div className="grid md:grid-cols-2 divide-y md:divide-y-0 md:divide-x divide-slate-200">
              <div className="p-5">
                <div className="text-xs font-bold uppercase tracking-widest text-emerald-700 mb-2">FOR · GPT-5</div>
                <p className="text-sm text-slate-800 whitespace-pre-wrap">{d.for_arg}</p>
              </div>
              <div className="p-5">
                <div className="text-xs font-bold uppercase tracking-widest text-red-700 mb-2">AGAINST · Claude 4.5</div>
                <p className="text-sm text-slate-800 whitespace-pre-wrap">{d.against_arg}</p>
              </div>
            </div>
            <div className="p-5 bg-blue-50 border-t border-blue-100">
              <div className="text-xs font-bold uppercase tracking-widest text-blue-700 mb-2 flex items-center gap-1"><Sparkles className="w-3.5 h-3.5"/>Neutral Summary · Gemini 3</div>
              <p className="text-sm text-slate-800 whitespace-pre-wrap">{d.summary}</p>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-slate-500">No debates yet.</div>}
      </div>
    </div>
  );
}
